<template>
    <div>
        <div id="mi_theysay_control">
            <div class="left">
                <a @click="toggle" class="pointer"><span>Próximas datas</span>&nbsp;&nbsp;{{show_title}}</a>
            </div>
        </div>
        <div id="mi_theysay" :class="{active:isShowing}">
            <div id="mi_theysay_add" v-show="isAdding">
                <br />
                <div class="flexsplit">
                    <div>
                        Data de início:<br/>
                        <v-date-picker v-model="current.beginDate" color="yellow darken-2"></v-date-picker>
                    </div>
                </div>
                <div class="flexsplit">
                    <v-text-field label="Todas as datas" v-model="current.othersDate"></v-text-field>
                </div>
                <div class="flexsplit">
                    <v-text-field label="Horário" v-model="current.time"></v-text-field>
                    <v-text-field label="Localização" v-model="current.location"></v-text-field>
                </div>

                <button class="fluke-btn" @click="add(index != undefined ? index : 'undefined')">Salvar</button>
                <button class="fluke-btn fluke-grey" @click="cancel">Cancelar</button>
            </div>
            <div id="mi_theysay_list" v-show="list.length && !isAdding">
				<table>
					<thead>
						<tr>
							<th>Data de Início</th>
							<th>Outras Datas</th>
							<th>Horário</th>
							<th>Investimento</th>
                            <th>&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in list" v-bind:key="index">
							<td>{{item.beginDate}}</td>
							<td>{{item.othersDate}}</td>
							<td>{{item.time}}</td>
							<td>{{item.budget}}</td>
                            <td class="editCol">
                                <button class="flake-btn" @click="edit_enable(item, index)"><i class="material-icons">edit</i></button>
                                <button class="flake-btn" @click="remove(index)"><i class="material-icons">delete</i></button>
                            </td>
						</tr>
					</tbody>
				</table>
            </div>
            <div id="mi_theysay_add_button" v-show="!isAdding">
                <button class="fluke-btn" @click="add_enable">Adicionar</button>
            </div>
        </div>
    </div>
</template>

<script>
import mi from './mi.js';

export default {
    mixins: [
        mi
    ],
    data: function(){
        return {
            current: {
                beginDate: new Date().toISOString().substr(0, 10),
                othersDate: '',
                time: '',
                location: '',
                budget: '',
                payment: ''
            }
        }
    },
    methods: {
        add_enable: function()
        {
            this.current = {
                beginDate: new Date().toISOString().substr(0, 10),
                othersDate: '',
                time: '',
                location: '',
                budget: '',
                payment: ''
            }
            this.isAdding = true;
            this.index = undefined;
        },
        edit_enable: function(item, index){
            this.current = item;
            this.index = index;
            this.isAdding = true;
        }
    }
}
</script>